/*---------------------------------------------------------------------------------------------
	 *  Copyright (c) Microsoft Corporation. All rights reserved.
	 *  Licensed under the MIT License. See License.txt in the project root for license information.
	 *--------------------------------------------------------------------------------------------*/

	// This file is generated by build/npm/postinstall.js. Do not edit.
self.webPackagePaths = {
  "@microsoft/applicationinsights-web": "dist/applicationinsights-web.js",
  "@vscode/vscode-languagedetection": "dist/lib/index.js",
  "iconv-lite-umd": "lib/iconv-lite-umd.js",
  "jschardet": "dist/jschardet.min.js",
  "tas-client-umd": "lib/tas-client-umd.js",
  "vscode-oniguruma": "release/main.js",
  "vscode-textmate": "release/main.js",
  "xterm": "lib/xterm.js",
  "xterm-addon-search": "lib/xterm-addon-search.js",
  "xterm-addon-unicode11": "lib/xterm-addon-unicode11.js",
  "xterm-addon-webgl": "lib/xterm-addon-webgl.js"
};